import React from 'react';
import { motion } from 'framer-motion';
import { FaStar, FaGoogle, FaCheckCircle, FaQuoteLeft } from 'react-icons/fa';

// Generate 15 Reviews
const reviews = [
    {
        id: 1,
        name: "Sophie Turner",
        role: "CMO, BrandBuzz",
        image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80",
        stars: 5,
        text: "The new customer portal is sleek, fast, and exactly what our users wanted. Technical execution was flawless.",
        date: "2 days ago"
    },
    {
        id: 2,
        name: "Alexander V.",
        role: "Global CTO, Fin",
        image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80",
        stars: 5,
        text: "Tech Inovant didn't just build code; they re-engineered our entire workflow. Unrivaled engineering quality.",
        date: "1 week ago"
    },
    {
        id: 3,
        name: "Tom Baker",
        role: "Head of Ops, BuildRight",
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80",
        stars: 5,
        text: "Automating our workflows saved us thousands of man-hours annually. The ROI was immediate.",
        date: "2 weeks ago"
    },
    {
        id: 4,
        name: "Linda Wu",
        role: "CEO, BankSafe",
        image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80",
        stars: 5,
        text: "Data integrity is critical for us. Tech Inovant provided secure, audit-ready architecture from day one.",
        date: "3 weeks ago"
    },
    {
        id: 5,
        name: "Marcus Chen",
        role: "Director, AI Labs",
        image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80",
        stars: 5,
        text: "Their understanding of Generative AI integration is lightyears ahead. Truly a future-proof partner.",
        date: "1 month ago"
    },
    {
        id: 6,
        name: "Elena Rodriguez",
        role: "VP Product, EduTech",
        image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80",
        stars: 5,
        text: "Seamless scalability. We went from 1k to 100k users overnight without a glitch.",
        date: "1 month ago"
    },
    {
        id: 7,
        name: "David Kim",
        role: "Founder, StartUp X",
        image: "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80",
        stars: 5,
        text: "Lightning fast delivery. They understood our MVP requirements better than we did.",
        date: "2 months ago"
    },
    {
        id: 8,
        name: "Sarah Jenkins",
        role: "CTO, GreenEnergy",
        image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80",
        stars: 5,
        text: "Complex IoT data visualization made simple. Our dashboard is now our greatest asset.",
        date: "2 months ago"
    },
    {
        id: 9,
        name: "James Wilson",
        role: "SVP, LogisticsGo",
        image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80",
        stars: 5,
        text: "Our supply chain visibility increased by 400%. The system pays for itself every week.",
        date: "3 months ago"
    },
    {
        id: 10,
        name: "Priya Patel",
        role: "Director, CloudNine",
        image: "https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80",
        stars: 5,
        text: "Migration to the cloud was painless. Zero downtime, maximum performance.",
        date: "3 months ago"
    },
    {
        id: 11,
        name: "Robert Fox",
        role: "CEO, SecureNet",
        image: "https://images.unsplash.com/photo-1500917293891-ef795e70e1f6?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80",
        stars: 5,
        text: "Pentesting results came back clean on the first run. Unheard of in this industry.",
        date: "4 months ago"
    },
    {
        id: 12,
        name: "Emily Davis",
        role: "Marketing Lead, Hype",
        image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80",
        stars: 5,
        text: "The website animation and interactions are stunning. Our bounce rate dropped by 60%.",
        date: "4 months ago"
    },
    {
        id: 13,
        name: "Michael Brown",
        role: "Ops Manager, FactoryZ",
        image: "https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80",
        stars: 5,
        text: "Digital twin implementation was flawless. We can now predict maintenance needs.",
        date: "5 months ago"
    },
    {
        id: 14,
        name: "Lisa Wong",
        role: "VP Sales, RetailPlus",
        image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80",
        stars: 5,
        text: "The e-commerce checkout flow is so smooth, our conversion rate doubled.",
        date: "5 months ago"
    },
    {
        id: 15,
        name: "Kevin White",
        role: "Founder, GameDev",
        image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80",
        stars: 5,
        text: "Multiplayer backend scaling was our bottleneck. Tech Inovant solve it in a week.",
        date: "6 months ago"
    }
];

const Testimonials = () => {
    return (
        <section className="bg-white pt-8 md:pt-12 pb-2 border-t border-slate-100 overflow-hidden relative font-sans">

            <div className="max-w-7xl mx-auto px-6 lg:px-12 mb-10 md:mb-16">
                <motion.h2
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    className="text-4xl md:text-5xl font-black text-slate-900 tracking-tight leading-tight mb-4"
                    style={{ fontFamily: '"Rajdhani", sans-serif' }}
                >
                    Unrivaled Engineering <span className="text-blue-600">Excellence</span>
                </motion.h2>
                <p className="text-lg text-slate-600 font-medium" style={{ fontFamily: '"Outfit", sans-serif' }}>
                    Trusted by 150+ Enterprise Leaders. Verified 5-Star Reviews.
                </p>
            </div>

            {/* Continuous Marquee Slider */}
            <div className="relative w-full">
                {/* Side Fade Masks for smooth entry/exit */}
                <div className="absolute top-0 left-0 w-32 h-full bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>
                <div className="absolute top-0 right-0 w-32 h-full bg-gradient-to-l from-white to-transparent z-10 pointer-events-none"></div>

                <div className="flex gap-6 animate-marquee-slow py-4 hover:pause">
                    {/* Triple the list to ensure smooth infinite loop for wider screens */}
                    {[...reviews, ...reviews, ...reviews].map((review, index) => (
                        <div
                            key={`${review.id}-${index}`}
                            className="flex-shrink-0 w-[350px] md:w-[400px] bg-white rounded-2xl p-6 border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_8px_30px_rgb(0,0,0,0.1)] transition-shadow duration-300 flex flex-col h-full"
                        >
                            {/* Profile Header */}
                            <div className="flex items-start justify-between mb-4">
                                <div className="flex items-center gap-3">
                                    <div className="relative">
                                        <img
                                            src={review.image}
                                            alt={review.name}
                                            className="w-12 h-12 rounded-full object-cover border border-slate-100"
                                        />
                                        <div className="absolute -bottom-1 -right-1 bg-blue-500 text-white p-0.5 rounded-full text-[8px]">
                                            <FaCheckCircle />
                                        </div>
                                    </div>
                                    <div>
                                        <h4 className="font-bold text-slate-900 text-sm" style={{ fontFamily: '"Rajdhani", sans-serif' }}>
                                            {review.name}
                                        </h4>
                                        <p className="text-xs text-slate-500 font-medium truncate max-w-[150px]" style={{ fontFamily: '"Outfit", sans-serif' }}>
                                            {review.role}
                                        </p>
                                    </div>
                                </div>
                                <FaGoogle className="text-xl text-slate-300" />
                            </div>

                            {/* Stars */}
                            <div className="flex text-amber-400 text-sm mb-4">
                                {[...Array(review.stars)].map((_, i) => (
                                    <FaStar key={i} />
                                ))}
                            </div>

                            {/* Text */}
                            <p className="text-slate-600 text-sm leading-relaxed mb-6 flex-grow font-medium" style={{ fontFamily: '"Outfit", sans-serif' }}>
                                "{review.text}"
                            </p>

                            {/* Footer */}
                            <div className="pt-4 border-t border-slate-50 flex items-center justify-between text-xs text-slate-400 mt-auto">
                                <span>{review.date}</span>
                                <span className="flex items-center gap-1 text-green-600 font-bold">
                                    <FaCheckCircle /> Verified Review
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Custom Animation CSS - Inline for portability */}
            <style jsx>{`
                @keyframes marquee {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-100%); } 
                }
                /* Adjusted speed for larger number of items - Slower for mobile readability */
                .animate-marquee-slow {
                    animation: marquee 180s linear infinite;
                    width: max-content;
                }
                .hover\\:pause:hover {
                    animation-play-state: paused;
                }
            `}</style>
        </section>
    );
};

export default Testimonials;
